import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "contanct" }
const _hoisted_2 = { class: "contact-header unselectable" }
const _hoisted_3 = { class: "location unselectable" }
const _hoisted_4 = { class: "location-map" }
const _hoisted_5 = {
  key: 0,
  class: "map-consent"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContactComp = _resolveComponent("ContactComp")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.STRINGS.CONTACT), 1)
    ]),
    _createVNode(_component_ContactComp),
    _createElementVNode("section", _hoisted_3, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "location-title" }, [
        _createElementVNode("h2", null, "Hier finden Sie uns")
      ], -1)),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.consentStatus === null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _cache[2] || (_cache[2] = _createElementVNode("p", null, [
                _createTextVNode(" Um die interaktive Karte zu sehen, müssen Sie zustimmen, dass "),
                _createElementVNode("a", { href: "/datenschutz#personal-data" }, "personenbezogene Daten"),
                _createTextVNode(" an "),
                _createElementVNode("a", { href: "/datenschutz#google-maps" }, "Google"),
                _createTextVNode(" übertragen werden. ")
              ], -1)),
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.acceptGoogleMaps && _ctx.acceptGoogleMaps(...args)))
              }, "Einwilligen"),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rejectGoogleMaps && _ctx.rejectGoogleMaps(...args)))
              }, "Nicht Einwilligen")
            ]))
          : _createCommentVNode("", true),
        (_ctx.consentStatus === true)
          ? (_openBlock(), _createElementBlock("iframe", {
              key: 1,
              src: _ctx.STRINGS.LOCATION_EMBED,
              width: "1000",
              height: "600",
              style: {"border":"0"},
              allowfullscreen: "",
              loading: "lazy",
              referrerpolicy: "no-referrer-when-downgrade"
            }, null, 8, _hoisted_6))
          : _createCommentVNode("", true),
        (_ctx.consentStatus === false)
          ? (_openBlock(), _createElementBlock("img", {
              key: 2,
              src: _ctx.ASSETS.MAP_IMAGE,
              alt: "map image",
              width: "1000",
              height: "600"
            }, null, 8, _hoisted_7))
          : _createCommentVNode("", true)
      ])
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("section", { class: "info-section" }, [
      _createElementVNode("h2", { class: "unselectable" }, "PARKMÖGLICHKEITEN:"),
      _createElementVNode("p", null, "Parkplatz: Grünenplatzstraße 1, 42899 Remscheid"),
      _createElementVNode("br"),
      _createElementVNode("h2", { class: "unselectable" }, "ÖFFENTLICHE VERKEHRSMITTEL:"),
      _createElementVNode("p", null, "S-Bahn Remscheid Lüttringhausen"),
      _createElementVNode("p", null, "Bushaltestelle Eisernstein - Remscheid")
    ], -1))
  ]))
}